import { environmentService, userService, postRequestHandler, getRequestHandler } from "@/utils/services";
import { compress, decompress } from 'lz-string';

let apiUrl = environmentService.apiUrlLogs;
let headers = { headers: userService.authHeader() };
export const logsService = {
    searchLogs,
    getmodules,
    getactions
};

async function searchLogs(logsSearch) {
    return await postRequestHandler(`${apiUrl}/logs`, logsSearch, headers);
}

async function getmodules() {
    return await getRequestHandler(`${apiUrl}/modules`, headers);
}

async function getactions() {
    return await getRequestHandler(`${apiUrl}/actions`, headers);
}


// WEBPACK FOOTER //
// ./src/utils/services/logs/log.service.js